export { default } from "./ListVentas";
